<article class="news-card">
  <div class="row news-card__inner">
    <fstr-image
      class="col-md-6 news-card__image pe-lg-4"
      [class.is--placeholder]="!news().image?.url"
      [image]="news().image || undefined"
      [width]="200"
      [height]="200"
      [colSpan]="{ sm: 2, lg: 3 }"
    ></fstr-image>

    <div class="news-card__header col-md-18">
      <div class="flex-1 min-width-0 pe-3">
        <div class="fs-body-xs d-flex gap-2 mb-2">
          <span class="text-primary flex-shrink-0">Nieuws | {{ news().publicationDate | newsDate }}</span>
          @if (news().subtitle) {
            <span class="text-truncate">{{ news().subtitle }}</span>
          }
        </div>
        <h3 class="h4 fw-semi mb-0 news-card__title">{{ news().title }}</h3>

        <a [routerLink]="news().routerLink || news().url" class="button button--primary mt-3 mt-xl-4 header-button">
          <span>Lees meer</span>
        </a>
      </div>

      @if (news().intro || news().text) {
        <div class="news-card__text flex-1">
          @if (news().intro) {
            <p class="max-lines-5 mb-max-lines">{{ news().intro | stripHtml }}</p>
          }
          @if (!news().intro && news().text) {
            <p class="max-lines-5 mb-max-lines">{{ news().text | stripHtml }}</p>
          }

          <a [routerLink]="news().routerLink || news().url" class="button button--primary mt-3 mt-xl-4 d-md-none">
            <span>Lees meer</span>
          </a>
        </div>
      }
    </div>
  </div>
</article>
